<template>
  <div>
    <a-modal
      :title="title"
      :visible="visible"
      width="450px"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-form
        @submit="handleSubmit"
        :form="form"
      >
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="球队logo"
              :labelCol="{lg: {span: 6}}"
              :wrapperCol="{lg: {span: 18} }"
              style="margin-bottom:5px;"
            >
              <upload ref="upload" :length="1" :imgs="teamLogo" @uploadSuccess="uploadSuccess" :cutImg="true" uploadTest="球队logo"></upload>
            </a-form-item>
            <a-form-item
                label="球队名称"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-input placeholder="请输入球队名称" v-decorator="['teamName', { rules: [{required: true, message: '请输入球队名称!'}]}]"/>
            </a-form-item>
            <a-form-item
                label="球队类型"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }">
              <a-select placeholder="选择球队类型" v-decorator="['programId', { rules: [{required: true, message: '请选择球队类型'}]}]">
                <a-select-option :value="0">默认</a-select-option>
                <a-select-option :value="item.programId"  v-for="(item, index) in programList" :key="index">{{ item.programName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import matchFun from '@comm/utils/matchFun'
import Upload from '@comm/upload/Upload'
export default {
  components: {
    Upload
  },
  data () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      teamLogo: [],
      matchFun: matchFun,
      programList: [],
      data: null,
      title: '新增球队'
    }
  },
  computed: {
    ...mapState({
      agencyInfo: state => state.agency.agencyInfo,
      agencyProgram: state => state.agency.agencyProgram
    })
  },
  methods: {
    show (data) {
      this.data = data
      this.teamLogo = []
      this.visible = true
      if (data !== null) {
        this.title = '修改球队信息'
        this.formData(this.data)
        this.teamLogo.push(this.matchFun.randomNumFile('teamLogo.jpg', data.teamLogo))
      } else {
        this.$nextTick(function () {
          this.form.setFieldsValue({
            teamName: '',
            programId: 4
          })
        })
      }
      this.findProgram()
    },
    findProgram () {
      this.programList = []
      this.$api.join.getProgram({agencyId: this.$route.query.agencyId}).then(res => {
        if (res.status === 0) {
          this.programList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    formData (data) {
      setTimeout(() => {
        this.form.setFieldsValue({
          teamName: data.teamName,
          programId: data.programId
        })
      })
    },
    uploadSuccess (e) {
      this.teamLogo = e
    },
    handleSubmit (e) {
      e.preventDefault()
      if (this.teamLogo.length === 0) {
        this.$message.error('请上传球队logo')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.teamName.length > 5) {
            this.$message.error('球队名称不能超过5个字')
            return
          }
          values.agencyId = this.agencyInfo.agencyId
          values.teamLogo = this.teamLogo[0].url
          if (this.data === null) {
            this.add(values)
          } else {
            values.id = this.data.id
            this.update(values)
          }
        }
      })
    },
    add (values) {
      this.$api.join.addMatchTeam(values).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.handleCancel()
        } else {
          this.$message.error(`失败`)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    update (values) {
      this.$api.join.updateMatchTeam(values).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.handleCancel()
        } else {
          this.$message.error(`失败`)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleCancel () {
      this.$emit('ok')
      this.visible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/center/modal/EditTeam.vue